import './w-latest-news.component.scss'
import { hotModuleReload } from '../../../components/common/utilities/hot-module-reload'

hotModuleReload()
